import { render, staticRenderFns } from "./ValTiposDocumentosNew.vue?vue&type=template&id=4d5a567c&"
import script from "./ValTiposDocumentosNew.vue?vue&type=script&lang=js&"
export * from "./ValTiposDocumentosNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports